<template lang="pug">
.side-nav
  .side-nav-wrapper
    //- small {{ order }}
    .fixed-nav
      #nav-search.searchbar(@click="openSearchModal")
        span.icon
          i.fa-solid.fa-magnifying-glass
        span  {{ $t("ui.search_team") }}
    .swith-mode-wrapper
      a.btn-swith(href='javascript:void(0);' @click="changeView('classic')")
        img.mode-icon(src='images/light/sparkles.svg')
        |  {{ $t("ui.classic_view") }}
        
    //- .tournament
    //-   router-link(to="/tournament" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
    //-     img.img-fluid(src='images/tournament-m.png')
    .tournament(v-if="SPECIAL_EVENTS[2]")
      a(href='javascript:void(0);' @click='setMenu0("event", "3", getEventDate("2026-06-11T12:00:00"))')
        img.img-fluid(src='images/worldcup.jpg')

    
    ul
      li
        router-link(to="/highlight" @click.native.prevent="closeSideNav")
          ThemeImage.icon(src='images/light/game-type/highlight.svg' alt='')
          |  {{ $t("ui.highlight") }}
    ul
      li
        router-link(to="/lobby" @click.native.prevent="closeSideNav")
          ThemeImage.icon(src='images/light/game-type/home.svg' alt='')
          |  {{ $t("ui.home") }}    
    sportsList(
      :order="order"
      :live="liveMenu"
      :today="todayMenu"
      :early="earlyMenu"
      :items="selectedMarket"
      :sports="menuList.sports"
      @setMenu2="setMenu2"
    )
    ul    
      li(v-if="filteredCasinoSuites.length > 0")
        a.sub-menu-btn.card-expanded(data-bs-toggle='collapse' href='#casino' role='button' aria-expanded='false' aria-controls='casino')
          ThemeImage.icon-inactive(src='images/light/game-type/casino.svg' alt='')
          ThemeImage.icon-active(src='images/light/game-type/casino-active.svg' alt='')
          |  {{ $t("ui.casino") }}
          span.arrow
        ul#casino.sub-menu.active.collapse.show
          li(v-for="suite in filteredCasinoSuites" :key="`casino-suite-${suite.id}`")
            router-link(:to="`/casino?suite=${suite.id}`" target="_blank" @click.native.prevent="openCasinoWindow($event, suite.id)")
              img.icon(:src="suite.icon" :alt="suite.name")
              |  {{ $t(suite.translationKey) }}
      li(v-if="slotItems.length > 0")
        router-link(to="/slotsMain" @click.native.prevent="closeSideNav") 
          ThemeImage.icon(src='images/light/game-type/slot.svg' alt='')
          |  {{ $t("ui.slots") }}
      li
        a(href='javascript:void(0);' @click='setMenu2x(57)')
          ThemeImage.icon(src='images/light/game-type/v-games.svg' alt='')
          |  {{ $t("ui.egames") }}
      li(v-if="!mmoMode && !brand && !thaiBrand")
        router-link(to="/w4d" target="_blank" onclick="window.open(this.href,'w4d','status=no,toolbar=no,menubar=no,location=no');return false;")
          ThemeImage.icon(src='images/light/sport/blue/4d.svg' alt='')
          |  {{ $t("ui.w4d") }}
      li(v-if="!mmoMode && ['MYR'].includes($store.getters.currencyCode)")
        router-link(to="/slots?mode=10" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
          ThemeImage.icon(src='images/light/game-type/poker.svg' alt='')
          |  {{ $t("ui.poker") }}
      li(v-if="!whiteLabel && esports2")
        router-link(to="/slots?mode=3" target="_blank" onclick="window.open(this.href,'esports2','status=no,toolbar=no,menubar=no,location=no');return false;")
          ThemeImage.icon(src='images/light/game-type/esports.svg' alt='')
          |  {{ $t("ui.esports2") }}
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { EventBus } from '@/library/_event-bus.js';
import naming from "@/library/_name.js";
import config from '@/config';
import acc from '@/library/_xhr-account';

import sportsList from "@/components/mobile/main/sportsList";

import mixinTypes from "@/library/mixinTypes";
import mixinProvider from "@/library/mixinProvider";
import mixinDelay from "@/library/mixinDelay";

export default {
  name: 'Sidebar',
  directives: {
    ClickOutside
  },
  components: {
    sportsList
  },
  mixins: [mixinTypes, mixinProvider, mixinDelay],
  computed: {
    brand() {
      return config.brand === 'IBCBET';
    },
    // COPA, EURO, WORLD CUP, OLYMPIC, CLUB WORLDCUP, WOMEN's EURO, NATION LEAGUE, FIFA CUP
    SPECIAL_EVENTS() {
      return [0, 0, this.wcMode ? 1 : 0, 0, 0, 0, 0, 0];
    },
    wcMode() {
      return config.wcMode;
    },
    whiteLabel() {
      return config.whiteLabel == '1';
    },
    esports2() {
      return config.esports2 == '1';
    },
    thaiBrand() {
      return config.brand == 'UBETT';
    },
    search() {
      return this.$store.getters.search;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    menu() {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (this.menu1) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    selectedMarket() {
      // Merge all three menus (live, today, early) to show sports with matches in any category
      const merged = {};
      
      // Collect all unique sport IDs from all three menus
      const allSportIds = new Set([
        ...Object.keys(this.liveMenu || {}),
        ...Object.keys(this.todayMenu || {}),
        ...Object.keys(this.earlyMenu || {})
      ]);
      
      // For each sport, use the menu entry with the highest match count (tn)
      allSportIds.forEach(sportId => {
        const live = this.liveMenu[sportId];
        const today = this.todayMenu[sportId];
        const early = this.earlyMenu[sportId];
        
        // Priority: live > today > early (based on highest tn value)
        let best = null;
        let maxTn = 0;
        
        if (live && live.tn > maxTn) {
          best = live;
          maxTn = live.tn;
        }
        if (today && today.tn > maxTn) {
          best = today;
          maxTn = today.tn;
        }
        if (early && early.tn > maxTn) {
          best = early;
          maxTn = early.tn;
        }
        
        if (best) {
          merged[sportId] = best;
        }
      });
      
      return merged;
    },
    filteredCasinoSuites() {
      return this.casinoSuites.filter(suite => suite.shouldShow);
    }
  },
  methods: {
    openSearchModal() {
      $('#search-modal').fadeIn();
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    closeSideNav(e) {
      // console.log('closeSideNav')
      $('body').removeClass('open-side-nav')
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    setMenu2x(mode) {
      const mi5 = {
        menuX: false,
        menuY: '0',
        menu0: 'all',
        menu1: 'today',
        menu2: parseInt(mode),
        menu3: 'hdpou'
      };

      this.$store.dispatch('layout/setMenuItems', mi5);
      // Prematch owns the market list. Emitting INVALIDATE from this always-mounted
      // sidebar used to start the request here and leave the V-Games page empty.
      if (this.$route.path === '/prematch') {
        EventBus.$emit('INVALIDATE');
      } else {
        this.$router.push('/prematch').catch(err => {});
      }
      $('body').removeClass('open-side-nav')
    },
    setMenu0(e, menuY, m, bt) {
      $('body').removeClass('open-side-nav')
      this.$store.dispatch("layout/setSelectedMatch", null);

      var mi5 = {};
      mi5["menuX"] = false;
      if (EventBus.cancelParlay) EventBus.cancelParlay();
      if (EventBus.cancelParlayMMO) EventBus.cancelParlayMMO();
      this.$store.dispatch("layout/setOptions", { property: "parlay", value: "" });
      $(".btn-parlay").removeClass("active");
      $(".btn-mmo-parlay").removeClass("active");

      if (menuY) {
        mi5["menuY"] = menuY.toString();
      } else {
        mi5["menuY"] = "0";
      }

      // mi5["menu1"] = e;
      mi5["menu2"] = this.menu2;
      switch (e) {
        case "live":
          mi5["menu0"] = "live";
          mi5["menu3"] = "hdpou";
          var newLive = {};
          newLive[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: newLive });
          break;
        case "mmoparlay":
          mi5["menu0"] = "parlay";
          mi5["menu3"] = "parlay";
          break;
        case "event":
          mi5["menu0"] = "event";
          mi5["menu1"] = m == null ? "today" : m;
          mi5["menu3"] = bt == null ? "hdpou" : bt;
          // Sidebar special events (e.g. World Cup) use normal soccer markets. If menu2
          // was left on a vgames id, OddsItem still treats it as vgames (vg1) and shows
          // m.GR_/m.CF_ labels instead of HDP / 1X2 text.
          if (config.vg1.includes(parseInt(mi5["menu2"], 10))) {
            mi5["menu2"] = 1;
          }
          break;
        default:
          var menu = this.getMenu(e);
          var sports = Object.keys(menu);
          var choosenSport = "1";
          if (this.menu2 != null) {
            choosenSport = this.menu2.toString();
          }
          if (!sports.includes(choosenSport)) {
            choosenSport = sports[0];
          }
          mi5["menu0"] = "all";
          mi5["menu2"] = parseInt(choosenSport);
          mi5["menu3"] = "hdpou";
          break;
      }

      var changed = true;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menuY"] != this.menuY) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]), mi5["menu1"]);
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        if (this.$route.path === '/prematch') {
          EventBus.$emit("INVALIDATE", mi5);
        } else {
          this.$router.push("/prematch").catch(err => {});
        }
      }
    },
    getEventDate(e) {
      const d1 = new Date();
      const d2 = new Date(e);
      return d1 >= d2 ? 'today' : 'early';
    },
    getEventDate2(e) {
      const d1 = new Date();
      const d2 = new Date(e);
      return d1 >= d2 ? null : 'orz';
    },
    setMenu2(e) {
      const sportId = parseInt(e);
      let selectedMenu1 = 'today';
      let selectedMenu0 = 'all';
      let selectedMenu = null;

      // Check market availability by priority: live > today > early
      if (this.liveMenu[sportId] && this.liveMenu[sportId].tn > 0) {
        selectedMenu1 = 'live';
        selectedMenu0 = 'live';
        selectedMenu = this.liveMenu[sportId];
      } else if (this.todayMenu[sportId] && this.todayMenu[sportId].tn > 0) {
        selectedMenu1 = 'today';
        selectedMenu0 = 'all';
        selectedMenu = this.todayMenu[sportId];
      } else if (this.earlyMenu[sportId] && this.earlyMenu[sportId].tn > 0) {
        selectedMenu1 = 'early';
        selectedMenu0 = 'all';
        selectedMenu = this.earlyMenu[sportId];
      }

      // Use chooseBetType to determine the appropriate menu3 value
      let selectedMenu3 = 'hdpou';
      if (selectedMenu) {
        selectedMenu3 = naming.chooseBetType(sportId.toString(), selectedMenu, this.menu3);
      }

      const mi5 = {
        menuX: false,
        menuY: '0',
        menu0: selectedMenu0,
        menu1: selectedMenu1,
        menu2: sportId,
        menu3: selectedMenu3
      };

      if (selectedMenu1 === 'live') {
        const options = {};
        options[sportId] = true;
        this.$store.dispatch('layout/setOptions', { property: 'live', value: options });
      }

      this.setDays(sportId);
      this.resetSelectLeague();
      this.clearSearch();
      this.$store.dispatch('layout/setMenuItems', mi5);
      if (this.$route.path === '/prematch') {
        EventBus.$emit('INVALIDATE', mi5);
      } else {
        this.$router.push('/prematch').catch(err => {});
      }
      $('body').removeClass('open-side-nav')
    },
    getMenu(e) {
      if (!this.menuList || !this.menuList.menu) {
        return {};
      }
      switch (e) {
        case "early":
          return this.menuList.menu["1"] || {};
        case "today":
          return this.menuList.menu["2"] || {};
        case "live":
          return this.menuList.menu["3"] || {};
        case "parlay":
          return this.menuList.menu["4"] || {};
        default:
          return {};
      }
    },
    openCasinoWindow(event, suiteId) {
      event.preventDefault();
      const href = `/casino?suite=${suiteId}`;
      window.open(href, '_blank', 'status=no,toolbar=no,menubar=no,location=no');
      $('body').removeClass('open-side-nav');
      return false;
    },
    // getTotalMarketCount() {
    //   let count = 0;
    //   for (let i = 0; i < this.order.length; i++) {
    //     count += this.menuList.sports[this.order[i]].tn;
    //   }
    //   return count;
    // }
    changeView(e) {
      let wloc = acc.changeView(e);
      window.location.href = wloc+ "?u=" + this.$store.getters.accountId + "&st=" + this.$store.getters.sessionToken;
    },
  }
};
</script>